export function createUniqueSwiperClasses(instanceID) {
    const id = instanceID?.replace(/[^a-zA-Z0-9]/g, '') ?? '';
    return {
        previousButton: `custom-swiper-prev-${id}`,
        nextButton: `custom-swiper-next-${id}`,
        previousButtonMobile: `custom-swiper-prev-mobile-${id}`,
        nextButtonMobile: `custom-swiper-next-mobile-${id}`,
        fraction: `custom-swiper-fraction-${id}`,
    };
}
